import { useCallback, useEffect, useRef } from 'react';
export const useIdle = (time: number, onIdle: () => void) => {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const reset = useCallback(() => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(onIdle, time);
  }, [time, onIdle]);
  useEffect(() => {
    const events = ['mousemove', 'keydown', 'mousedown', 'scroll'];
    events.forEach(e => window.addEventListener(e, reset));
    reset();
    return () => {
      if (timer.current) clearTimeout(timer.current);
      events.forEach(e => window.removeEventListener(e, reset));
    };
  }, [reset]);

  return { resetIdle: reset };
};
